export const organizerData = [
  {
    name: "Mariano Vazquez",
    src: "https://secure.meetupstatic.com/photos/member/5/3/1/8/highres_70881272.jpeg",
    alt: "Mariano Vazquez coorganizer",
  },
  {
    name: "Leila Ybañez",
    src: "https://secure.meetupstatic.com/photos/member/9/6/3/1/highres_288758449.jpeg",
    alt: "Leila Ybañez coorganizer",
  },
  {
    name: "Leonardo Galante",
    src: "https://secure.meetupstatic.com/photos/member/1/1/3/9/highres_255784409.jpeg",
    alt: "Leonardo Galante coorganizer",
  },
  {
    name: "Carlos Manotas",
    src: "https://secure.meetupstatic.com/photos/member/a/d/4/5/highres_283424357.jpeg",
    alt: "Carlos Manotas coorganizer",
  },
  {
    name: "Caro Amarillo",
    src: "https://secure.meetupstatic.com/photos/member/9/9/6/2/highres_271239266.jpeg",
    alt: "Caro Amarillo coorganizer",
  },
  {
    name: "Caru",
    src: "https://secure.meetupstatic.com/photos/member/b/2/b/2/highres_269745746.jpeg",
    alt: "Caru coorganizer",
  },
  {
    name: "sebasjm",
    src: "https://secure.meetupstatic.com/photos/member/1/1/a/3/highres_250204515.jpeg",
    alt: "sebasjm organizer",
  },
  {
    name: "César Kästli",
    src: "https://secure.meetupstatic.com/photos/member/e/7/d/f/highres_255359359.jpeg",
    alt: "César Kästli event organizer",
  },
  {
    name: "Gonzalo Aguirre",
    src: "https://secure.meetupstatic.com/photos/member/6/0/8/0/highres_257304704.jpeg",
    alt: "Gonzalo Aguirre coorganizer",
  },
];
